import { variant } from 'styled-system';

const sizeVariant = variant({
  prop: 'size',
  variants: {
    small: {
      px: 'button.small.px',
      py: 'button.small.py',
      fontSize: 'headings.6',
      fontWeight: 'medium',
      lineHeight: 'button.0',
    },
    medium: {
      px: 'button.medium.px',
      py: 'button.medium.py',
      fontSize: 'headings.5',
      fontWeight: 'medium',
      lineHeight: 'button.1',
    },
    large: {
      px: 'button.large.px',
      py: 'button.large.py',
      fontSize: 'headings.4',
      fontWeight: 'medium',
      lineHeight: 'button.1',
    },
  },
});

export default sizeVariant;
